exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img_head[data-v-0fd1fc76]{width:658px;height:530px}.img_head>img[data-v-0fd1fc76]{width:100%;height:100%}", ""]);

// exports
